import { Button } from "@material-ui/core";
import useLanguageStore from "@stores/languageStore";
import React from "react";
import { withTranslation } from "react-i18next";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error("ErrorBoundary caught an error:", error, errorInfo);
		this.setState({
			error,
			errorInfo,
		});
	}

	handleReset = () => {
		this.setState({ hasError: false, error: null, errorInfo: null });
	};

	render() {
		const { t } = this.props;
		const { language } = useLanguageStore.getState();
		const isRtl = language === "he";

		if (this.state.hasError) {
			return (
				<div className="flex justify-center items-center min-h-screen p-8 bg-gray-100">
					<div className="max-w-2xl text-center bg-white p-12 rounded-lg shadow-md">
						<h1 className="text-3xl mb-4 text-red-600">{t("error.title")}</h1>
						<p className="text-lg mb-8 text-gray-600 leading-relaxed">
							{t("error.message")}
						</p>
						{import.meta.env.DEV && this.state.error && (
							<details
								className={`${isRtl ? "text-right" : "text-left"} my-8 p-4 bg-gray-100 rounded text-sm`}
							>
								<summary className="cursor-pointer mb-2 font-bold">
									{t("error.errorDetails")}
								</summary>
								<pre className="text-left overflow-x-auto whitespace-pre-wrap break-words">
									{this.state.error.toString()}
								</pre>
								<pre className="text-left overflow-x-auto whitespace-pre-wrap break-words">
									{this.state.errorInfo.componentStack}
								</pre>
							</details>
						)}
						<Button
							variant="contained"
							color="primary"
							onClick={this.handleReset}
							className="!m-2"
						>
							{t("common.tryAgain")}
						</Button>
						<Button
							variant="outlined"
							onClick={() => window.location.reload()}
							className="!m-2"
						>
							{t("common.refreshPage")}
						</Button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default withTranslation()(ErrorBoundary);
